<template>
    <div>
        <table class="table w-full border">
            <thead>
                <tr>
                    <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-gray py-2 px-2" sort-by="order_number">Order #</sortable-header>
                    <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-gray py-2 px-2" sort-by="customer">Customer</sortable-header>
                    <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-gray py-2 px-2" sort-by="order_date_for_sort">Order Date</sortable-header>
                    <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-gray py-2 px-2" sort-by="ship_date_for_sort">Shipping Date</sortable-header>
                    <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2" sort-by="discount">Discount</sortable-header>
                    <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2" sort-by="delivery">Delivery</sortable-header>
                    <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2" sort-by="total">Total</sortable-header>
                    <!-- <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2" sort-by="profit">Profit</sortable-header> -->
                    <!-- <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2" sort-by="margin">Margin</sortable-header> -->
                    <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2" sort-by="tax">Tax</sortable-header>
                    <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2" sort-by="commission">Commission</sortable-header>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in data.sales" :key="item.id">
                    <td>
                        <Link class="block px-2 py-1 hover:font-bold text-indigo-600" :href="route('orders.show', item.id)">
                            {{ item.order_number }}
                        </Link>
                    </td>
                    <td>{{ item.customer }}</td>
                    <td>{{ item.order_date }}</td>
                    <td>{{ item.ship_date }}</td>
                    <td class="text-right">{{ item.discount ? `$${item.discount}` : '-' }}</td>
                    <td class="text-right">{{ item.delivery ? `$${item.delivery}` : '-' }}</td>
                    <td class="text-right">${{ item.total }}</td>
                    <!-- <td class="text-right">{{ item.profit }}</td> -->
                    <!-- <td class="text-right">{{ item.margin == 0 ? '--' : `${item.margin * 100}%` }}</td> -->
                    <td class="text-right">{{ item.tax ? `$${item.tax}` : '-' }}</td>
                    <td class="text-right">{{ item.commission || '-' }}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="4"></td>
                    <td class="text-right">${{ data.total_discount }}</td>
                    <td class="text-right">${{ data.total_delivery }}</td>
                    <td class="text-right">${{ data.grand_total }}</td>
                    <!-- <td class="text-right" colspan="2"></td> -->
                    <td class="text-right">${{ data.grand_tax }}</td>
                    <td class="text-right">${{ data.total_commission }}</td>
                </tr>
            </tfoot>
        </table>

        <div class="flex justify-end my-2">
            <div class="flex flex-col text-right">
                <div class="px-4 mb-1">Subtotal (Not Taxable)</div>
                <div class="px-4 mb-1">Subtotal (Taxable)</div>
                <div class="px-4 mb-1">Tax</div>
                <div class="px-4 mb-1">Discount</div>
                <div class="border-t px-4 mb-1">Total</div>
                <div class="px-4 mb-1" v-if="data.fundraising_code">
                    Donation Amount {{ data.fundraising_code !== 'All' ? `(${data.fundraising_code.percent}%)` : '' }}
                </div>
                <div class="px-4 mb-1">Subtotal (Not Taxable) - After Discount</div>
                <div class="px-4 mb-1">Subtotal (Taxable) - After Discount</div>
                <div class="px-4">Tax - After Discount</div>
            </div>
            <div class="flex flex-col text-right">
                <div class="font-bold mb-1">${{ data.grand_subtotal_no_tax }}</div>
                <div class="font-bold mb-1">${{ data.grand_subtotal_tax }}</div>
                <div class="font-bold mb-1">${{ data.grand_tax }}</div>
                <div class="font-bold mb-1">${{ data.total_discount }}</div>
                <div class="font-bold mb-1 border-t">${{ data.grand_total }}</div>
                <div class=" mb-1" v-if="data.fundraising_code">
                    ${{ data.total_donations }}
                </div>
                <div class="font-bold mb-1">${{ data.grand_subtotal_no_tax_after_discount }}</div>
                <div class="font-bold mb-1">${{ data.grand_subtotal_tax_after_discount }}</div>
                <div class="font-bold">${{ data.grand_tax_after_discount }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';
import SortableHeader from '@/Shared/SortableHeader';

export default {
    name: 'Sales',

    components: {
        Link,
        SortableHeader,
    },

    props: ['data', 'sort_column', 'sort_direction'],
    emits: ['sort'],

    methods: {
        handleSort(sort) {
            this.$emit('sort', sort, 'sales');
        },
    },
}
</script>